import {
  LOADING_DASHDOARD,
  SAVE_INDIVIDUAL,
  SAVE_DASHDOARD,
  TEMP_CREATED_INDIVIDUAL_EMAIL
} from "appRedux/constants";

const storedIndividual = JSON.parse(sessionStorage.getItem("individual"));
const INIT_STATE = {
  temp_email: null,
  loading_dashboard: false,
  dashboard: [],
  individual: storedIndividual
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TEMP_CREATED_INDIVIDUAL_EMAIL: {
      return {
        ...state,
        temp_email: action.payload
      };
    }
    case SAVE_INDIVIDUAL: {
      return {
        ...state,
        individual: action.payload
      };
    }
    case LOADING_DASHDOARD: {
      return {
        ...state,
        loading_dashboard: true
      };
    }
    case SAVE_DASHDOARD: {
      return {
        ...state,
        loading_dashboard: false,
        dashboard: action.payload
      };
    }
    default:
      return state;
  }
};
